import * as React from "react";

function SvgDelete1(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 407.521 407.521"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M335.94 114.944H71.581a10.45 10.45 0 00-7.837 2.612 8.88 8.88 0 00-2.612 7.837l27.167 236.669c3.186 26.093 25.436 45.647 51.722 45.453h131.657c27.026.385 49.791-20.104 52.245-47.02l22.465-236.147a8.882 8.882 0 00-2.612-6.792 10.446 10.446 0 00-7.836-2.612zM303.026 359.45c-1.642 15.909-15.366 27.803-31.347 27.167H140.022c-15.694.637-29.184-11.024-30.825-26.645l-26.122-224.13h241.371l-21.42 223.608zM374.079 47.026H266.454V30.307c.58-16.148-12.04-29.708-28.188-30.288a29.104 29.104 0 00-1.591-.014h-65.829c-16.156-.299-29.494 12.555-29.793 28.711-.01.53-.005 1.061.014 1.591v16.718H33.442c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449h340.637c5.771 0 10.449-4.678 10.449-10.449s-4.679-10.448-10.449-10.448zM245.556 30.307v16.718h-83.592V30.307a8.36 8.36 0 018.881-9.404h65.829a8.359 8.359 0 018.882 9.404z" />
    </svg>
  );
}

export default SvgDelete1;
